import React, { useState } from 'react';
import PageBody from '../../components/pagebody/PageBody';
import SelectDropdown from "../../components/dropdown/selectdropdown/SelectDropdown"
import PrePayHistory from "./prepayhistory/PrePayHistory"
import StateFilingHistory from './statefilinghistory/StateFilingHistory';
import FilingHistory from './filinghistory/FilingHistory';
import W8W9RequestHistory from './w8w9Requesthistory/W8W9RequestHistory';
import Label from '../../components/label/Label';
import { useEffect } from 'react';
import styles from './HistorySection.styles'
import useTxSearchParams from '../../../libs/txsearchparams/TxSearchParamsHook';
import MemberUserHistory from './memberuserhistory/MemberUserHistory';
import StatePayrollFilingHistory from './statepayrollfilinghistory/StatePayrollFilingHistory';
import { FILING_HISTORY_TEXT, FILING_HISTORY_VALUE, MEMBER_USER_HISTORY_TEXT, MEMBER_USER_HISTORY_VALUE, PREPAY_HISTORY_TEXT, PREPAY_HISTORY_VALUE, STATE_FILING_HISTORY_TEXT, STATE_FILING_HISTORY_VALUE, STATE_PAYROLL_FILING_HISTORY_TEXT, STATE_PAYROLL_FILING_HISTORY_VALUE, W8_W9_REQUEST_HISTORY_TEXT, W8_W9_REQUEST_HISTORY_VALUE } from './Constants';

export default function HistorySection() {
	const historyPages = [
		{ label: PREPAY_HISTORY_TEXT, value: PREPAY_HISTORY_VALUE },
		{ label: STATE_FILING_HISTORY_TEXT, value: STATE_FILING_HISTORY_VALUE },
		{ label: FILING_HISTORY_TEXT, value: FILING_HISTORY_VALUE },
		{ label: W8_W9_REQUEST_HISTORY_TEXT, value: W8_W9_REQUEST_HISTORY_VALUE },
		{ label: MEMBER_USER_HISTORY_TEXT, value: MEMBER_USER_HISTORY_VALUE },
		{ label: STATE_PAYROLL_FILING_HISTORY_TEXT, value: STATE_PAYROLL_FILING_HISTORY_VALUE },
	]
	const [queryParams, setQueryParams] = useTxSearchParams();
	const [selectedHistory, setSelectedHistory] = useState()

	const getHistory = () => {
		switch (queryParams.get('page')) {
			case STATE_FILING_HISTORY_VALUE:
				return <StateFilingHistory />
			case FILING_HISTORY_VALUE:
				return <FilingHistory />
			case W8_W9_REQUEST_HISTORY_VALUE:
				return <W8W9RequestHistory />
			case MEMBER_USER_HISTORY_VALUE:
				return <MemberUserHistory />
			case STATE_PAYROLL_FILING_HISTORY_VALUE:
				return <StatePayrollFilingHistory />
			default:
				return <PrePayHistory />
		}
	}
	const handlePageChange = (name, selectedOption) => {
		setSelectedHistory(selectedOption)
	}

	useEffect(() => {
		if (!queryParams.has('page')) {
			setSelectedHistory(historyPages[0])
		} else {
			setSelectedHistory(historyPages.find(page => page.value === queryParams.get('page')) ?? historyPages[0])
		}
	}, [])

	useEffect(() => {
		if(selectedHistory){
			queryParams.set('page', selectedHistory?.value);
			setQueryParams(queryParams);
		}
	}, [selectedHistory]);

	return (
		<PageBody>
			{selectedHistory &&
				<div>
					<div style={styles.navigationSelector}>
						<Label>Navigate To</Label>
						<SelectDropdown
							name="navigator"
							value={{ label: selectedHistory?.label, value: selectedHistory?.value }}
							prefixProps={{ text: "" }}
							placeHolder='Navigate To'
							onSelectCb={(name, selectedOption) => handlePageChange(name, selectedOption)}
							options={historyPages}

						/>
					</div>
					{getHistory()}

				</div>
			}
		</PageBody>
	)
}